import { PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';

import {
  PageHeader,
  PageHeaderBackProps,
} from '@/components/shared/PageHeader';
import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import useNewUiScope from '@/data/hook/shared/useNewUiScope';
import useAuth from '@/data/hook/useAuth';
import { isStaff } from '@/functions/auth';

function Root({ children }: PropsWithChildren) {
  const isAppShellEnabled = useNewUiScope('appShell');
  const { user } = useAuth();

  return (
    <ConditionalRenderer
      condition={!isAppShellEnabled || isStaff(user?.userType)}
    >
      {children}
    </ConditionalRenderer>
  );
}

function Back({ className, ...props }: PageHeaderBackProps) {
  const isAppShellEnabled = useNewUiScope('appShell');

  return (
    <PageHeader.Back
      {...props}
      className={twMerge(
        isAppShellEnabled && 'hidden lg:inline-flex',
        className,
      )}
    />
  );
}

Root.displayName = 'ShellHeaderFallback';
Back.displayName = 'ShellHeaderFallback.Back';

const ShellHeaderFallback = Object.assign(Root, { Back });

export default ShellHeaderFallback;
